var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 17C18 17.1989 17.921 17.3896 17.7803 17.5303C17.6397 17.6709 17.4489 17.75 17.25 17.75H0.75C0.551088 17.75 0.360322 17.6709 0.21967 17.5303C0.0790176 17.3896 0 17.1989 0 17C0 16.801 0.0790176 16.6103 0.21967 16.4696C0.360322 16.329 0.551088 16.25 0.75 16.25H17.25C17.4489 16.25 17.6397 16.329 17.7803 16.4696C17.921 16.6103 18 16.801 18 17ZM1.5 14.75H16.5C16.6989 14.75 16.8897 14.6709 17.0303 14.5303C17.171 14.3896 17.25 14.1989 17.25 14V13.25C17.2473 11.193 16.4769 9.21102 15.0897 7.69217C13.7025 6.17331 11.7983 5.2269 9.75 5.0382V4.0422C10.036 3.8771 10.2595 3.62226 10.3858 3.31719C10.5122 3.01212 10.5344 2.67389 10.4489 2.35494C10.3634 2.03599 10.1751 1.75415 9.91314 1.55313C9.65118 1.35212 9.3302 1.24316 9 1.24316C8.6698 1.24316 8.34882 1.35212 8.08686 1.55313C7.82489 1.75415 7.63657 2.03599 7.55111 2.35494C7.46565 2.67389 7.48782 3.01212 7.61418 3.31719C7.74054 3.62226 7.96404 3.8771 8.25 4.0422V5.0382C6.20167 5.2269 4.29751 6.17331 2.9103 7.69217C1.5231 9.21102 0.752723 11.193 0.75 13.25V14C0.75 14.1989 0.829018 14.3896 0.96967 14.5303C1.11032 14.6709 1.30109 14.75 1.5 14.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/Restaurant.e53b195b4cf91bd726fc17d14c6f5d26.svg";
export { ForwardRef as ReactComponent };